import { useEffect, useState } from "react";
import UAParser, { UAParserInstance } from "ua-parser-js";

//https://www.npmjs.com/package/ua-parser-js
interface ClientProps {
  userAgent?: string;
}

const useClientInfo = ({ userAgent }: ClientProps) => {
  const [client, setClient] = useState<UAParserInstance>();
  useEffect(() => {
    if (!!window && !!window?.navigator) {
      const client = new UAParser(userAgent ?? window?.navigator?.userAgent);
      setClient(client);
    }
  }, [userAgent]);
  return client;
};
export default useClientInfo;
